<script lang="ts" setup>
    import { computed } from 'vue';
    import { hasSlot } from '../../lib/VueHelpers';
    import { ref, nextTick } from 'vue';
    import * as utils from '../../lib/ChoiceUtils';
    import type { IToolbarDivItem } from '../../lib/Toolbar';

    const props = withDefaults(defineProps<{
        baseClass?: string,
        content?: string,
        onMouseEnterClass?: string,
        tooltip?: string,
        contextValue?: string | number,
        enabled?: boolean,
        performAction: (contextValue?: string | number) => Promise<void>,
    }>(), {
        baseClass: "",
        content: "",
        enabled: true,
        onMouseEnterClass: "",
    });

    const emits = defineEmits(["onClick", "onHover", "onMouseEnter", "onMouseLeave"]);
    const divId = `toolBarDiv_${utils.randomId(6)}`;

    // Computed
    const divClass = computed<string>(()=> props.baseClass);
    const enterClass = computed<string>(() => props.onMouseEnterClass);
    const divContent = computed<string>(() => props.content);

    async function OnClick()
    {
        if(!props.enabled) return;
 
    if (undefined === props.performAction)
    {
        return;
    }

    await nextTick();   // Allow UI to update if the call is actually a sync function
    await props.performAction(props.contextValue);

        emits("onClick");
    }

    function OnMouseEnter(event) 
    {
        if(!props.enabled) return;
        const el = event.currentTarget;
        if (el && enterClass.value) el.classList.add(enterClass.value);
        emits("onMouseEnter");
    }

    function OnMouseLeave(event)
    {
        if(!props.enabled) return;
        const el = event.target;
        if (el && enterClass.value) el.classList.remove(enterClass.value);
        emits("onMouseLeave");
    }
</script>

<script lang="ts">
    export default {
        methods: {
        
        }
    }
</script>

<template>
    <div :class="divClass" v-on:click="OnClick" v-bind:id="divId"
        v-on:mouseenter="OnMouseEnter" v-html="divContent" v-bind:title="props.tooltip" 
        v-on:mouseleave="OnMouseLeave">
    </div>
</template>

